var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",attrs:{"id":"app"}},[_c('div',{staticClass:"row"},[_c('contract-form',{staticClass:"no-print col-12 col-md-4"}),_c('div',{staticClass:"col-12 col-md-8"},[_c('div',{staticClass:"row"},[_c('contract',{staticClass:"col-12"}),_c('button-bar',{staticClass:"no-print col-12"})],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }